import produce from 'immer';
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types, ConsultarUsuarios } from './types';

export const INITIAL_STATE: ConsultarUsuarios = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerActionRotaSP,
): ConsultarUsuarios {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_USUARIOS_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.CONSULTAR_USUARIOS_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_USUARIOS_FAILURE: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_USUARIOS_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
